var render = function render(){var _vm=this,_c=_vm._self._c;return _c('product-list',{attrs:{"id":_vm.listId,"cloud-env":"mapping","getParams":_vm.getParams}})
}
var staticRenderFns = []

export { render, staticRenderFns }